import { Link } from "react-router-dom";
import { ArrowRight, TrendingUp } from "lucide-react";
import { CASE_STUDIES } from "../data/caseStudies";
import ScrollReveal from "./ScrollReveal";

/** Shows a "coming soon" state until CASE_STUDIES has real, auditable entries — see caseStudies.ts. */
export default function CaseStudyIndex() {
  if (CASE_STUDIES.length === 0) {
    return (
      <div className="mx-auto max-w-md rounded-2xl bg-foam-100 p-8 text-center">
        <TrendingUp className="mx-auto h-6 w-6 text-ocean-800/30" strokeWidth={1.5} />
        <p className="mt-3 text-sm text-ocean-800/60">
          Structured case studies with measurable outcomes are coming soon.
        </p>
      </div>
    );
  }

  const sorted = [...CASE_STUDIES].sort(
    (a, b) => new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime()
  );

  return (
    <div className="grid gap-6 sm:grid-cols-2">
      {sorted.map((cs, i) => (
        <ScrollReveal key={cs.id} delay={i * 0.08}>
          <Link
            to={`/success-stories/case-studies/${cs.slug}`}
            className="block h-full rounded-2xl bg-white p-6 shadow-sm ring-1 ring-ocean-900/5 transition-colors hover:ring-teal-400/40"
          >
            <h3 className="font-display font-semibold text-ocean-950">{cs.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-ocean-800/70">{cs.challenge}</p>
            <span className="mt-4 inline-flex items-center gap-1 text-xs font-semibold text-teal-600">
              Read case study
              <ArrowRight className="h-3 w-3" />
            </span>
          </Link>
        </ScrollReveal>
      ))}
    </div>
  );
}
